import { useQuery } from '@tanstack/react-query';
import { trackError } from 'Utils/errorMonitoring';
import { getRelatedInvoices } from 'Services/invoices';

const defaultRelatedInvoices = {
    "invoices_imported": [],
    "invoices_issued": [],
    "invoices_corrected": [],
    "invoices_corrective": []
}

export default function useRelatedInvoices(id) {
    const { data: relatedInvoices = defaultRelatedInvoices, isLoading } = useQuery({
        queryKey: ['invoices', 'related', id],
        queryFn: () => getRelatedInvoices(id),
        onError: (error) => {
            trackError(error);
        },
    });

    return {
        importedInvoices: relatedInvoices.invoices_imported,
        issuedInvoices: relatedInvoices.invoices_issued,
        correctedInvoices: relatedInvoices.invoices_corrected,
        correctiveInvoices: relatedInvoices.invoices_corrective,
        isLoading,
    };
}
